export const ONBOARDING_PATHS = [
  {
    key: 'investor',
    title: 'Investor',
    description: 'Find, acquire, improve, and manage your rental portfolio.',
    icon: 'pi-chart-line',
  },
  {
    key: 'tenant',
    title: 'Tenant',
    description: 'Apply for a home and access your tenant workspace.',
    icon: 'pi-home',
  },
  {
    key: 'contractor',
    title: 'Contractor',
    description: 'View opportunities and complete awarded project work.',
    icon: 'pi-wrench',
  },
  {
    key: 'rehab_field_inspector',
    title: 'Rehab Field Inspector',
    description: 'Document job sites and independently verify contractor work.',
    icon: 'pi-camera',
  },
  {
    key: 'wholesaler',
    title: 'Wholesaler',
    description: 'Submit and track property opportunities for investors.',
    icon: 'pi-building',
  },
  {
    key: 'virtual_assistant',
    title: 'Virtual Assistant',
    description: 'Coordinate the workflows and assignments entrusted to you.',
    icon: 'pi-users',
  },
  {
    key: 'real_estate_agent',
    title: 'Real Estate Agent',
    description: 'Collaborate on listings, showings, offers, and transactions.',
    icon: 'pi-briefcase',
  },
];

